import { CommonModule } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { Component, inject, Inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterModule } from '@angular/router';
import { ApiRequestService, DialogComponent, DialogConfiguration, DialogService, FilterPipe, ToastmessageService } from '@prekog/common-ui';
import { DeleteSpecialityRequest } from './deletespecialityrequest';
import { GetSpecialitySelectorItemListResponse } from './getspecialityselectoritemlistresponse';
import { SpecialitySelectorItem } from './specialityselectoritem';

@Component({
    selector: 'pf-specialities',
    templateUrl: './specialities.component.html',
    styleUrls: ['./specialities.component.scss'],
    standalone: true,
    imports: [MatIconModule, CommonModule, FilterPipe, RouterModule, FormsModule]
})
export class SpecialitiesComponent implements OnInit {
    deleteSpecialityUrl = '/admin/delete-speciality';
    getSpecialitySelectorItemListUrl = '/admin/getSpecialitySelectorItemList';

    regeneroBaseUrl = '';
    searchText = '';
    specialitySelectorItemList?: SpecialitySelectorItem[];
    private _dialogService = inject(DialogService);

    constructor(
        public _router: Router,
        private _apiRequestService: ApiRequestService,
        @Inject('REGENERO_BASE_URL') private _regeneroBaseUrl: string,
        private _toastMessageService: ToastmessageService,
    ) {
        this.regeneroBaseUrl = _regeneroBaseUrl;
    }
    ngOnInit(): void {
        if (!sessionStorage.getItem('token')) {
            this._router.navigateByUrl('/');
        } else {
            this.getSpecialities();
        }
    }

    getSpecialities() {
        this._apiRequestService
            .sendRequest<{}, GetSpecialitySelectorItemListResponse>(this.regeneroBaseUrl, {}, true, this.getSpecialitySelectorItemListUrl)
            .subscribe((response) => {
                this.specialitySelectorItemList = response.specialitySelectorItemList;
            });
    }

    openDeleteSpecialityDialog(specialityselectoritem: SpecialitySelectorItem) {
        const dialogConfiguration: DialogConfiguration = {
            messageKey: 'speciality.deleteConfirmMessage',
            targetData: specialityselectoritem.name
        };

        this._dialogService.openDialog(
            DialogComponent,
            dialogConfiguration,
            () => this._deleteSpeciality(specialityselectoritem.routerLink!)
        );
    }

    private _deleteSpeciality(specialityRouterLink: string): void {
        const deleteSpecialityRequest: DeleteSpecialityRequest = {
            specialityRouterLink: specialityRouterLink
        };

        this._apiRequestService
            .sendRequest<
                DeleteSpecialityRequest,
                HttpResponse<any>
            >(this.regeneroBaseUrl, deleteSpecialityRequest, true, this.deleteSpecialityUrl, true)
            .subscribe(() => {
                this.specialitySelectorItemList = this.specialitySelectorItemList?.filter(
                    (existingItem) => existingItem.routerLink !== specialityRouterLink
                );
            });
    }
}
